var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('ContestInfoBar'),_c('LabList',{attrs:{"contestMode":true,"contestId":_vm.contest_id,"contestLabIds":_vm.contest_lab_ids,"showTitle":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }